import {
  Component,
  OnInit,
  InjectionToken,
  Inject,
  OnDestroy,
} from '@angular/core';
import { Facet } from 'search/facets/models/resource-facet';
import {
  Observable,
  Subscription,
} from 'rxjs';
import { FacetState } from 'search/facets/models/facet-state';

export const FACET_FILTER_COMPONENT_DATA = new InjectionToken<FacetState>('FACET_FILTER_COMPONENT_DATA');

@Component({
  selector: 'app-facet-filter-container',
  template: `
    <app-facet-filter [facet]="facet" class="facet-filter" *ngIf="(isApplied || facet && facet.count > 0)"></app-facet-filter>`,
  styles: [
    `.facet-filter {
      box-sizing: border-box;
      display: flex;
      height: 48px;
      align-items: center;
      width: 100%;
    }`],
})
export class FacetFilterContainerComponent implements OnInit, OnDestroy {

  public facet: Facet;
  public isLoading = true;
  public isApplied: boolean;
  private subscriptions = new Subscription();

  constructor(
    @Inject(FACET_FILTER_COMPONENT_DATA) public componentData: Observable<FacetState<Facet>>,
  ) {
  }

  public ngOnInit() {
    this.subscriptions.add(this.componentData.subscribe((facet) => {
      this.facet = facet.selected;
      this.isApplied = !!facet.applied;
      this.isLoading = facet.isLoading;
    }));
  }

  public ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

}
